import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';

/** Container inside which all toasts will render. */
@Injectable()
export class OverlayContainerService implements OnDestroy {
    protected _containerElements: Map<string, HTMLElement> = new Map();

    constructor(@Inject(DOCUMENT) protected _document: any) {}

    ngOnDestroy() {
        this._containerElements.forEach((value, key) => this.removeContainerElement(key));
    }

    /**
     * This method returns the overlay container element. It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @returns the container element
     */
    getContainerElement(id: string): HTMLElement {
        if (!this._containerElements.has(id)) {
            this._createContainer(id);
        }
        return this._containerElements.get(id);
    }

    removeContainerElement(id: string): void {
        const ele = this._containerElements.get(id);
        if (ele && ele.parentNode) {
            ele.parentNode.removeChild(ele);
            this._containerElements.delete(id);
        }
    }

    generateEmptyHtmlElement(type: string): HTMLElement {
        return this._document.createElement(type);
    }

    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     */
    protected _createContainer(id: string): void {
        const container: HTMLElement = this._document.createElement('i');
        container.id = id;
        this._document.body.appendChild(container);
        this._containerElements.set(id, container);
    }
}
